import tw, { styled } from 'twin.macro';

import { fadeInAnimation } from '../../../../shared/utils';

export const IntroWrapper = styled.section`
  ${fadeInAnimation};
  ${tw`text-center`};
  font-family: var(--formFont) !important;
  color: var(--formTextColor) !important;
  background-size: auto;
  min-height: 100vh;
  ${({ formPageStyles }) => formPageStyles || ''};

  ${({ customCss }) =>
    customCss &&
    `
      && {
        ${customCss.replace(/;/g, ' !important;')}
      }
    `}
`;

export const IntroBody = styled.div`
  ${tw`w-4/5 mx-auto my-0 pt-5 pb-16`}

  button {
    ${tw`mt-12 py-4.5 px-16 rounded-full cursor-pointer uppercase box-border outline-none border-none text-center`}
    color: var(--buttonColor, #ffffff) !important;
    background-color: var(--buttonBackground, #00afbf) !important;
    min-width: 60%;
    font-weight: 500;
    transition: all 0.3s ease-in-out;
    font-family: var(--formFont) !important;
    box-shadow: 0 0 4px 0 rgb(0 0 0 / 10%), 0 4px 8px 0 rgb(0 0 0 / 15%);

    :hover {
      filter: brightness(0.8);
    }
  }

  @media screen and (max-width: 768px) {
    width: 90%;
  }
`;

export const FormTitle = styled.h1`
  font-family: var(--formFont) !important;
  font-size: var(--titleFontSize) !important;
  ${({ underline }) =>
    underline &&
    `
      border-bottom: 1px solid var(--formTextColor, rgba(34,36,38,.15));
    `}
`;

export const FormPreRequisite = styled.div`
  width: 100%;
  max-width: 500px;
  margin: 30px auto 0 auto;
  display: flex;
  flex-direction: column;
  gap: 20px;
  justify-content: center;
`;

export const RespondentInfo = styled.div`
  flex: 1;
  width: 100%;
  text-align: left;

  h4 {
    margin: 0;
    margin-bottom: 5px;
    font-family: var(--formFont) !important;
  }

  input {
    width: 100%;
    border: 1px solid #bbb;
    padding: 10px 5px;
    border-radius: 3px;
    outline: none;
    margin: 0;
    font-family: var(--formFont) !important;

    :focus {
      border-color: #85b7d9;
    }
  }

  > span {
    color: #555;
    font-size: 11px;
    font-family: var(--formFont) !important;
  }

  > span#error {
    color: brown;
  }
`;

export const MarkDownWrapper = styled.div`
  margin-top: 40px;
  text-align: var(--formTextAlign) !important;

  .pre-wrap {
    white-space: pre-wrap;
    font-family: var(--formFont) !important;

    h1,
    h2,
    h3,
    h4,
    h5,
    strong {
      font-family: var(--formFont) !important;
      font-weight: 500;
    }

    a {
      color: #4183c4;
      opacity: 0.9;
      text-decoration: underline;

      :hover {
        opacity: 1;
      }
    }

    ol,
    ul {
      display: block;
      list-style-position: inside;
    }

    iframe {
      border: none;
      max-width: 100%;
    }
  }
`;
